export { default } from './RateCard'
